import * as React from "react";
import { MoreVertical16Regular } from "@fluentui/react-icons";
import { IDistribution } from "../../../../repertoire/types/usageTypes/IDistribution";
import { hideModal, showModal, showYesNoPrompt, showUpdateFieldsModal, showMessage } from "../../../../redux/reducers/ModalReducer";
import { clearModalSearchResults, updateUsageField, setEditableFields, startWorkflowSession, nextWorkflowInSession, addUsageDetailsShareIPRow, addMatchWorkToUsage, addMatchLicenseToUsage, addUsageDetailsRowData, addMatchProductToUsage } from "../../../../redux/reducers/RepertoireReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import { getDataAction } from "../../../components/toolBar/ToolbarHelper";
import { getUsageDataAction } from "../../../components/usageComponents/toolBar/ToolbarHelper";
import { ALL_ROLES, SAVE_CHANGES_STATE_KEY, SAVE_METHOD_TOOLBAR, UPDATE_USAGES_ROLE, UPDATE_USAGES_ADVANCED_ROLE, USAGE_MAINTENANCE_TOOLBAR, WORK_MAINTENANCE_TOOLBAR, VIEW_COMPONENT_ROLE, USAGE_MAINTENANCE_GENERAL_DATA_VIEW, USAGE_PAGE_VIEW,
SEARCH_VIEW_USAGES, SEARCH_VIEW, USAGE_ROWS_SECTION_KEY, DATA_GRID_TABLE, 
CONFIGURE_USAGES_DETAILS_ROLE} from "../../../Consts";
import UsageMaintenanceGeneralDataView from "../usageMaintenanceGeneralDataView/UsageMaintenaceGeneralDataView";
import UsageMaintenanceToolbar from "../usageMaintenanceToolbar/UsageMaintenanceToolbar";
import { IRepertoireField } from "../../../types/IRepertoireField";
import {
    CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY,
    PRODUCT_MAINTENANCE_GROUP,
    WORK_MAINTENANCE_GROUP,
} from "../../../ConfigurationConsts";
import { SearchRequests } from "../../../services/SearchRequests";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { ITreeData } from "../../../types/ITreeData";
import { IWorkflowSearchResult } from "../../../types/IWorkflowSearchResult";
import { IWorkflowParams } from "../../../types/IWorkFlowParams";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import { CleanUploadFilesState } from "../../../../redux/reducers/DataIngestionReducer";
import { IUsageGroupLocation } from "../../../types/usageTypes/IUsageGroupLocation";
import { IUsageGroupSetListAdditional } from "../../../types/usageTypes/IUsageGroupSetListAdditional";
import { IUsageGroupVenueDetails } from "../../../types/usageTypes/IUsageGroupVenueDetails";
import { IUsagePool } from "../../../types/usageTypes/IUsagePool";
import { IUsagePoolSearchQuery } from "../../../types/usageTypes/IUsagePoolSearchQuery";
import { IUsagePoolState } from "../../../../redux/types/IUsagePoolState";
import { IWorksSearchQuery } from "../../../types/IWorksSearchQuery";
import { IWorksSearchResult } from "../../../types/IWorksSearchResult";
import { IMatchProductsSearchQuery } from "../../../types/usageTypes/IMatchProductsSearchQuery";
import { IMatchWorksSearchQuery } from "../../../types/usageTypes/IMatchWorksSearchQuery";
import { IUsagesSearchQuery } from "../../../types/usageTypes/IUsagesSearchQuery";
import { IMatchWorksSearchResult } from "../../../types/usageTypes/IMatchWorksSearchResult";
import { IDistributionType } from "../../../types/usageTypes/IDistibutionType";
import { IMatchingProductsRowData } from "../../../types/usageTypes/IMatchingProductsRowData";
import { ILicenseUsageSearchQuery } from "../../../types/usageTypes/ILicenseUsageSearchQuery";
import { ICustomerVenue } from "../../../types/ISetListVenue";
import { IComponentView } from "../../../../redux/types/ComponentView";
import UsageMaintenanceGridsView, { OPENED_FROM_WORKFLOW_STRING } from "../usageMaintenanceGridsView/UsageMaintenanceGridsView";
import { IComponentViewsPreference } from "../../../../redux/types/IComponentViewsPreference";
import { IUsageDetailsRowData } from "../../../types/usageTypes/IUsageDetailsRowData";
import { IActiveExtendedData } from "../../../../redux/types/IActiveExtendedData";
import { IActiveAccordion } from "../../../../redux/types/IActiveAccordion";
import { IResultsPerPage } from "../../../../redux/types/IResultsPerPage";
import { IProductSearchResult } from "../../../types/IProductSearchResult";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";

export const SCREEN_SIZE_BIG_ENOUGH_FOR_TWO_SCREENS = 1100;
export interface IUsageMaintenancePageProps {
    usageGroup?: IUsageGroupState;
    usageMaintenanceGeneralViewData: IRepertoireComponentDataItem;
    toggleExtendedMetaData: (extendedMetaDataName: string, componentName: string, paneIndex?: number) => void;
    activeExtendedData?: string[];
    usageMaintenanceGridsViewData: IRepertoireComponentDataItem;
    usageDataGridTableData: IRepertoireComponentDataItem;
    activeTab: number;
    tabs: ITabReduxItem[];
    showModal: typeof showModal;
    hideModal: typeof hideModal;
    clearModalSearchResults: typeof clearModalSearchResults;
    searchViewData: IRepertoireComponentDataItem;
    searchViewDataMatchingLicense: IRepertoireComponentDataItem;
    searchViewDataModal: IRepertoireComponentDataItem;
    searchResultsTableData: IRepertoireComponentDataItem;
    searchSuccessful?: boolean;
    usageMaintenanceToolbarData?: IRepertoireComponentDataItem;
    usageMaintenanceMatchingWorksToolbar?: IRepertoireComponentDataItem;
    usageMaintenanceSaveResultData?: IRepertoireComponentDataItem;
    resetMessageBanner: () => void;
    showYesNoPrompt: typeof showYesNoPrompt;
    currentUser?: string;
    saveChanges: (updatedUsage: IUsageGroupState,
        isWorkflowSession: boolean,
        workflowsSessionItems?: IWorkflowSearchResult[],
        currentWorkflowIndex?: number,
        activeTab?: number,
        isOpenForWorkflowSession?: boolean) => void;
    updateUsageField: typeof updateUsageField;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFieldsDataView?: IRepertoireComponentDataItem;
    setEditableFields: typeof setEditableFields;
    updateComponentFieldsItems: (fields: IRepertoireField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    updateFields?: (fields: IRepertoireField[], componentName: string) => void;
    editableFields?: IRepertoireField[];
    distributions: IDistribution[];
    pools?: IUsagePool[];
    getPools?: () => void;
    getDistributions?: () => void;
    dataGridTableData?: IRepertoireComponentDataItem;
    lookupValues: ILookupDictionary;
    workMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem;
    productMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem;
    getWorkDetails: (dataSource: string, workID: number, lookups: ILookupDictionary, otherIndicatorsWorkFlagTypes: string[], readonlyIndicatorsWorkFlagTypes: string[], dataActions?: IDataActionToolbar[], workMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem, formats?: FormatFields[], openEntityForWorflowSession?: boolean, isOpenedInSecondTab?: boolean) => void;
    getProductDetails: (
        dataSource: string,
        productCoreID: number,
        productMaintenanceGeneralDataView: IRepertoireComponentDataItem,
        formats: FormatFields[],
        openEntityForWorflowSession?: boolean,
        openNewTab?: boolean,
        id1?: string,
        id2?: string,
        productType?: string,
        originOfRevision?: string,
        enableCuesheet?: boolean,
        cuesheetDatasource?: any,
        productionType?: string,
        musicDuration?: number[],
        isOpenedInSecondTab?: boolean,
    ) => void;
    getSources: () => void;
    lookupSources?: ITreeData[];
    workflowFieldsData?: IRepertoireComponentDataItem;
    isWorkflowSessionStarted?: boolean;
    startWorkflowSession?: typeof startWorkflowSession;
    cancelWorkflowSession?: (activeTab: number) => void;
    nextWorkflowItem?: typeof nextWorkflowInSession;
    skipWorkflowItem?: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]) => void;
    workflowSessionItems?: IWorkflowSearchResult[];
    currentWorkflowIndex?: number;
    isOpenForWorkflowSession?: boolean;
    skipWorkWorkflowItem: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]
        , lookups: ILookupDictionary
        , otherIndicatorsWorkFlagTypes: string[]
        , dataActions: IDataActionToolbar[]
        , workMaintenanceGeneralDataViewData: IRepertoireComponentDataItem
        , formats: FormatFields[]
        , readonlyIndicatorsWorkFlagTypes: string[]) => void;
    formatFields?: FormatFields[];
    refreshUsageGroupDetails?: (usageID: string, activeTabItem: ITabReduxItem) => void;
    saveWorkflow?: (workflowparams: IWorkflowParams) => void;
    roles?: string[];
    matchingSearchViewDefaults?: {
        usageMatchingSearchDefaultsProducts?: string[],
        usageMatchingSearchDefaultsWorks?: string[]
    }
    addUsageDetailsShareIPRow?: typeof addUsageDetailsShareIPRow;
    addUsageDetailsRowData?: typeof addUsageDetailsRowData;
    containerDetailsWindowComponentData: IComponentDataItem;
    getFilesystems: (isRepertoireModule?: boolean) => void;
    getDataIngestionComponentData: () => void;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    updateLocation: (newLocation: IUsageGroupLocation) => void,
    updateSetListAdditional: (newSetListAdditional: IUsageGroupSetListAdditional) => void,
    updateUsageGroupVenueDetails: (newVenueDetails: IUsageGroupVenueDetails) => void,
    updateWorkflowAndEntityStatus: (workflowparams: IWorkflowParams, approvalStatus?: boolean) => void;
    updateClaimWorkflowAndEntityStatus?: (workflowparams: IWorkflowParams, callFrom: string, refreshDetails: () => void) => void;
    searchUsagePools: (query: IUsagePoolSearchQuery) => void;
    sources?: ITreeData[];
    getUsagePool: (poolId: number, matchingSources: ITreeData[]) => void;
    pool?: IUsagePoolState;
    updatedScroll?: number;
    expandedUsageDetailsRow?: number[];
    expandUsageDetail?: (index: number) => void;
    dataSource?: string;
    searchWorks?: (query: IWorksSearchQuery, modalOpen: boolean) => void;
    worksSearchResults?: IWorksSearchResult[];
    expandedWorkResults: number[];
    expandAll: boolean;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    expandWorkResult?: (workResult: number) => void;
    expandAllResults?: () => void;
    currentPage?: number;
    resetPagination?: (repertoireSection: string) => void;
    getUsagePoolsByDistributionCode: (distributionCode: string) => void;
    updatePagination?: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    sortSearchResults?: (name: string, results: any) => void;
    username?: string;
    searchUsages?: (query: IUsagesSearchQuery, modalOpen: boolean, usageType: string, lookupSources: ITreeData[], continuationToken?: string) => void;
    searchMatchWorks?: (query: IMatchWorksSearchQuery, modalOpen: boolean) => void;
    searchMatchProducts?: (query: IMatchProductsSearchQuery, modalOpen: boolean) => void;
    matchWorkSearchResult?: IMatchWorksSearchResult[];
    matchProductsSearchResult?: IProductSearchResult[];
    expandedMatchWorkResults?: number[];
    distributionTypes?: IDistributionType[];
    usageMatchingDefaultsWorks?: string[];
    getUsageMatchingDefaultsWorks?: () => void;
    addMatchworkToUsage?: typeof addMatchWorkToUsage;
    addMatchProductToUsage?: typeof addMatchProductToUsage;
    usageExpandAllResults?: () => void;
    expandMatchWorkResult?: (matchWorkResults: number) => void;
    enableCuesheet?:boolean;
    cuesheetDatasource?:any;
    addNewWork: (lookups: ILookupDictionary, actionList?: IDataActionToolbar[], isNew?: boolean, workMaintenanceGeneralDataView?: IRepertoireComponentDataItem, formats?: FormatFields[], workGroupId?: string, workGroup?: string, paneIndex?: number,isFromUsage?:boolean,usage?:IUsageGroupState,isOpenedInSecondTab?: boolean) =>void;
    paneIndex?:number;
    getUsageDetails?: (usageID: string, lookupValues?: ILookupDictionary, openEntityForWorflowSession?: boolean, reGroupIds?:Number[], openedFrom?: string, paneIndex?: number) => void;
    saveRegroupedUsageGroup?:(reGroupedUsage:IUsageGroupState,currentPane?:number) =>void;
    incrementTempID?: () => void;
    enableRegroupAndDeleteUI?:boolean;
    searchLicenses?: (query: ILicenseUsageSearchQuery) => void;
    licensesSearchResults?: any;
    addMatchLicenseToUsage?: typeof addMatchLicenseToUsage;
    setActivePane: (pane: number) => void;
    licenseVenues?:ICustomerVenue[];
    settingsModalViewData: IRepertoireComponentDataItem;
    updateComponentViews: (componentViews: any[]) => void;
    getComponentViews: (componentName: string, componentInstance: string) => void;
    componentViews?: any;
    usageMaintenanceActiveComponentView?: IComponentView;
    usageMaintenanceGridViewsDetailsActiveComponentView?: IComponentView;
    setActiveComponentView?: (activeComponentView: IComponentView) => void;
    usageType?: string,
    componentViewPreference?: IComponentViewsPreference;
    activeComponentView?: IComponentView;
    contributorTypes?: string[];
    nameTypes?: string[];
    defaultActiveExtendedData?: IActiveExtendedData[];
    updateUserPreferences: (
        allResultsPerPage: IResultsPerPage[], 
        activeAccordions: IActiveAccordion[], 
        newActiveAccordionName?: string, 
        accordionExpanded?: boolean, 
        componentName?: string, 
        indexOfFirstResult?: number, 
        indexOfLastResult?: number, 
        resultsPerPage?: number, 
        repertoireSection?: string,
        componentViewPreference?: IComponentViewsPreference,
        activeExtendedData?: IActiveExtendedData[],
        newExtendedDataName?: string,
        extendedMetaDataExpanded?: boolean,
    ) => void;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    showMessage: typeof showMessage;
    manualMergeUsage: (usageGroup: IUsageGroupState, targetUsageGroupID: number, mergeOption: string, paneIndex?: number) => void;
    usageGroupMergeOptions?: string[];
    isUsageTabDefaultSetToMatchConfiguration?: boolean;
    usageNumberInSearchExclude?: string[];
}

interface IUsageMaintenancePageState {
    toolbarWidth: number;
    isCompleteWorkflowOnSave: boolean;
    dataAction: IDataActionToolbar[];
}

const UsageMaintenancePage: React.FC<IUsageMaintenancePageProps> = ({
    searchUsagePools,
    searchViewDataModal,
    roles,
    usageMaintenanceToolbarData,
     lookupSources,
     getComponentViews, 
     getSources,
     containerDetailsWindowComponentData,
     getUsageMatchingDefaultsWorks,
     getDataIngestionComponentData,
     cleanUploadFilesState,
     getFilesystems,
     resetMessageBanner,
     expandUsageDetail,
     expandMatchWorkResult,
    saveChanges, 
    usageGroup, 
    tabs, 
    activeTab, 
    isWorkflowSessionStarted, 
    workflowSessionItems, 
    currentWorkflowIndex,
    isOpenForWorkflowSession,
    getWorkDetails,
    lookupValues, 
    workMaintenanceGeneralDataViewData,
    getProductDetails,
    productMaintenanceGeneralDataViewData,
    enableCuesheet,
    cuesheetDatasource,
    refreshUsageGroupDetails,
    usageMaintenanceGeneralViewData,
    usageMaintenanceGridsViewData,
    usageDataGridTableData,
    showModal,
    hideModal,
    nameTypes,
    clearModalSearchResults,
    usageMaintenanceSaveResultData,
    currentUser,
    showYesNoPrompt,
    updateUsageField,
    editableFieldsDataView,
    showUpdateFieldsModal,
    setEditableFields,
    editableFields,
    updateComponentFieldsItems,
    distributions,
    pools,
    getPools,
    getDistributions,
    workflowFieldsData,
    startWorkflowSession,
    cancelWorkflowSession,
    nextWorkflowItem,
    skipWorkflowItem,
    formatFields,
    skipWorkWorkflowItem,
    saveWorkflow,
    matchingSearchViewDefaults,
    addUsageDetailsShareIPRow,
    updateLocation,
    updateSetListAdditional,
    updateUsageGroupVenueDetails,
    updateWorkflowAndEntityStatus,
    updateClaimWorkflowAndEntityStatus,
    sources,
    getUsagePool,
    pool,
    updatedScroll,
    usageMaintenanceMatchingWorksToolbar,
    searchViewData,
    searchResultsTableData,
    dataSource,
    searchWorks,
    worksSearchResults,
    indexOfFirstResult,
    searchUsages,
    searchMatchProducts,
    searchMatchWorks,
    indexOfLastResult,
    resultsPerPage,
    expandWorkResult,
    expandAllResults,
    currentPage,
    resetPagination,
    updatePagination,
    sortSearchResults,
    username,
    matchWorkSearchResult,
    matchProductsSearchResult,
    expandedMatchWorkResults,
    expandedWorkResults,
    expandAll,
    searchSuccessful,
    usageMatchingDefaultsWorks,
    distributionTypes,
    addMatchworkToUsage,
    usageExpandAllResults,
    addNewWork,
    paneIndex,
    getUsageDetails,
    saveRegroupedUsageGroup,
    incrementTempID,
    enableRegroupAndDeleteUI,
    searchLicenses,
    licensesSearchResults,
    addMatchLicenseToUsage,
    setActivePane,
    licenseVenues,
    usageMaintenanceActiveComponentView,
    usageMaintenanceGridViewsDetailsActiveComponentView,
    settingsModalViewData,
    updateComponentViews,
    componentViews,
    setActiveComponentView,
    componentViewPreference,
    activeComponentView,
    expandedUsageDetailsRow,
    searchViewDataMatchingLicense,
    getUsagePoolsByDistributionCode,
    contributorTypes,
    toggleExtendedMetaData,
    activeExtendedData,
    defaultActiveExtendedData,
    addUsageDetailsRowData,
    updateUserPreferences,
    defaultActiveAccordions, 
    allResultsPerPage,
    addMatchProductToUsage,
    showMessage,
    manualMergeUsage,
    usageGroupMergeOptions,
    isUsageTabDefaultSetToMatchConfiguration,
    usageNumberInSearchExclude,
}) => {

    const onSetActiveComponentView = (activeComponentView: IComponentView) => { 
        const componentName = activeComponentView.componentInstance === USAGE_ROWS_SECTION_KEY ? "usageMaintenanceGridView" : "usageMaintenanceGeneralDataView";
        setActiveComponentView && setActiveComponentView(activeComponentView);
        const newComponentViewPreference = {
            ...componentViewPreference,
            [componentName]: activeComponentView.viewName};

        updateUserPreferences(
            allResultsPerPage,
            defaultActiveAccordions,
            undefined,
            undefined,
            undefined,
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            undefined,
            newComponentViewPreference,
            undefined,
            undefined,
        );
    }

    const updateUsageFieldLocal = (value: any, fieldName: IRepertoireStateKeys, _paneIndex?: number, markChangesMade?: boolean) => {
        return updateUsageField(value, fieldName, paneIndex, markChangesMade);
    }

    const saveUsage = () => {
        if (isCompleteWorkflowOnSave) {
            if (usageGroup.workflows && usageGroup.workflows[0] && usageGroup.workflows[0].status) {
                usageGroup.workflows[0].status = "Completed";
            }
        }
        saveChanges(usageGroup, isWorkflowSessionStarted, workflowSessionItems, currentWorkflowIndex + 1, activeTab, isOpenForWorkflowSession);
    }

    const getUpdateRoleDisabled = (): boolean => {
        if (roles && (roles.includes(UPDATE_USAGES_ROLE) || roles.includes(ALL_ROLES) || roles.includes(CONFIGURE_USAGES_DETAILS_ROLE))) {
            return false;
        }
        return true;
    }

    const newAddUsageDetailsRowData = (value: IUsageDetailsRowData[], usageRowViewIndex: number, usageDetailsIndex: number, fieldName: string) => {
        return addUsageDetailsRowData(value, usageRowViewIndex, usageDetailsIndex, fieldName);
    }


    
    const getDataActionLocal = () => {

        const actionList: IDataActionToolbar[] = [];

        const save: IDataActionToolbar = {
            action: saveUsage,
            component: USAGE_MAINTENANCE_TOOLBAR,
            method: SAVE_METHOD_TOOLBAR,
            name: usageMaintenanceToolbarData.fields.find(save => save.name === SAVE_CHANGES_STATE_KEY).data,
            icon: '',
            isReadOnly: getUpdateRoleDisabled()
        };
        actionList.push(save);

        return actionList;
    }

    const toolbarParentRef = React.useRef<HTMLDivElement | null>(null);
    const [toolbarWidth, setToolbarWidth] = React.useState<number | null>(null);
    const [isCompleteWorkflowOnSave, setIsCompleteWorkflowOnSave] = React.useState<boolean>(true);
    const [dataAction, setDataAction] = React.useState<IDataActionToolbar[]>(() => getDataActionLocal());

    React.useEffect(() => {
        const query: IUsagePoolSearchQuery = {
            poolCode: "",
            cat1: "",
            cat2: "",
            allocationRule: ""
        };
        searchUsagePools(query);
    }, [searchUsagePools]);

    const toggleExtendedMetaDataLocal = (extendedMetaDataName: string, componentName: string, paneIndex?: number) => {
        toggleExtendedMetaData(extendedMetaDataName, componentName, paneIndex)

            updateUserPreferences(
                allResultsPerPage,
                defaultActiveAccordions,
                undefined,
                undefined,
                componentName,
                indexOfFirstResult,
                indexOfLastResult,
                resultsPerPage,
                undefined,
                undefined,
                undefined,
                extendedMetaDataName,
                undefined,
            );
    }

    const getUpdateAdvancedRoleEnabled = (): boolean => {
        if (roles && (roles.includes(UPDATE_USAGES_ADVANCED_ROLE) || roles.includes(ALL_ROLES) || roles.includes(CONFIGURE_USAGES_DETAILS_ROLE))) {
            return true;
        }
        return false;
    }

    React.useEffect(() => {
         getComponentViews(USAGE_MAINTENANCE_GENERAL_DATA_VIEW, USAGE_PAGE_VIEW);
         getComponentViews(DATA_GRID_TABLE, USAGE_ROWS_SECTION_KEY);

        if (!lookupSources) {
            getSources();
        }

        if (!containerDetailsWindowComponentData || !containerDetailsWindowComponentData.fields || containerDetailsWindowComponentData.fields.length === 0) {
            getDataIngestionComponentData();
        }

        
        getFilesystems(true);
        cleanUploadFilesState();
        getUsageMatchingDefaultsWorks && getUsageMatchingDefaultsWorks();

        if (!pools || pools.length === 0) {
            getPools?.();
        }
        if (!distributions || distributions.length === 0) {
            getDistributions?.();
        }

    }, []);

    const calculateWeightCategory = (weight: number): string => {
        let low: number = 1000;
        let med: number = 5000;

        if (weight) {
            if (weight < low)
                return "Low";
            else if (weight >= low && weight < med)
                return "Med";
            else if (weight >= med)
                return "High";
        }
        else
            return "";
    }

    const undoChanges = () => {
        return null;
    }

    const resetMessageBannerLocal = () => {
        resetMessageBanner();
    }

    const expandUsageDetailRow = (index: number) => {
        expandUsageDetail(index);
    }
    const expandMatchWorkResultLocal = (index: number) => {
        expandMatchWorkResult(index);
    }

    const getWorkDetailsLocal = (dataSource: string, workID: number, isOpenedInSecondTab?: boolean) => {
        const isScreenWidthBigEnoughForTwoScreens = window.innerWidth > SCREEN_SIZE_BIG_ENOUGH_FOR_TWO_SCREENS;
        const dataActionList = getDataAction(dataSource, WORK_MAINTENANCE_TOOLBAR);
        const formatFields = SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
            .then(formats => {
                getWorkDetails(dataSource, workID, lookupValues, tabs[activeTab].otherIndicatorWorkFlagTypes, tabs[activeTab].readonlyIndicatorWorkFlagTypes, dataActionList, workMaintenanceGeneralDataViewData, formats, undefined,  isScreenWidthBigEnoughForTwoScreens && isOpenedInSecondTab);
            });
    }

    const getProductDetailsLocal = (dataSource: string, tableItem: IMatchingProductsRowData, isOpenedInSecondTab?: boolean) => {
        const isScreenWidthBigEnoughForTwoScreens = window.innerWidth > SCREEN_SIZE_BIG_ENOUGH_FOR_TWO_SCREENS;
        const formatFields = SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, PRODUCT_MAINTENANCE_GROUP)
            .then(formats => {
                getProductDetails(dataSource, tableItem.productCoreID, productMaintenanceGeneralDataViewData, formats, undefined, undefined, tableItem.id1, tableItem.id2, tableItem.type, tableItem.originOfRevision, enableCuesheet, cuesheetDatasource, undefined, undefined, isScreenWidthBigEnoughForTwoScreens && isOpenedInSecondTab);
            });
    }
    const refreshUsageGroupDetailsLocal = () => {
        let activeTabItem = tabs[activeTab];

        refreshUsageGroupDetails(activeTabItem.usageMaintenanceState.usageGroup.id, activeTabItem)
    }

    const completeWorkflowOnSave = (value: boolean) => {
        setIsCompleteWorkflowOnSave(value);
    }

    const toolbarMergeUsage = (usageGroupIds: number[], mergeOption: string) => {
        manualMergeUsage(usageGroup, usageGroupIds[0], mergeOption, paneIndex);
    }

        const isWorkFlowShown = usageGroup != null && usageGroup.workflows != null && usageGroup.workflows.length > 0;
        const changesMade = tabs[activeTab].changesMade;
        const isReadonly: boolean = tabs[activeTab].isReadonly;
        const openedFrom =  workflowSessionItems && workflowSessionItems.length > 0 ? OPENED_FROM_WORKFLOW_STRING : tabs[activeTab]?.openedFrom;
        const isValidationWorkflow = isWorkFlowShown && usageGroup!.workflows[0].workflowType === "Validation";

        if (openedFrom === 'workflow' && isValidationWorkflow &&
            usageGroup!.workflows[0].status === "Completed") {

            // It is set to true before the changes are made in the backend,
            // but depends on the property saveSuccess when showing the message in UsageSaveResult.tsx
            // We use 'else if' as cannot be both, but can be none of them. 
            // The order of checking does not matter.
            if (tabs[activeTab].approvedSuccessful !== undefined) {
                tabs[activeTab].approvedSuccessful = true;
            } 
            else if (tabs[activeTab].rejectedSuccessful !== undefined) {
                tabs[activeTab].rejectedSuccessful = true;
            }     
        }

        if (usageGroup) {
            const {
                id,
                fullTitle,
                fullContributor,
                fullPerformer,
                sourceMajor,
                sourceMinor,
                usageType,
                matchStatus,
                allocationStatus,
                allocations,
                remittingSocietyWorkCode,
                distributionCode,
                totalWeight,
                productType,
                location,
                setListAdditional,
                venueDetails,
                rejectReason,
                poolCode,
                setListArtist,
                customerVenues,
                catOne,
                catTwo,
                relatedPoolOptions,
                mergeThisUsage
            } = usageGroup;
            if(distributions && distributions.length){
                var distributionStatus: string = distributions.find((d) => d.distributionCode === distributionCode)?.distributionStatus;
            }

            const isNewUsageGroup = Boolean(
                tabs?.[activeTab]?.usageMaintenanceState?.isNew
            );
            const normalizedUsageType = (usageType || "").replace(/\s+/g, "").toLowerCase();
            const isUsageToProduct = normalizedUsageType === "usagetoproduct";
            const hasUsageTypeSelected = Boolean(usageType && usageType.trim().length > 0);
            const needsProductTypeSelection = isNewUsageGroup && isUsageToProduct;
            const hasProductTypeSelected = Boolean(productType && productType.trim().length > 0);
            const canRenderUsageFields =
                hasUsageTypeSelected && (!needsProductTypeSelection || hasProductTypeSelected);

            return (
                <div className="usageMaintenancePage">
                    <div><span className="title">{fullTitle}</span></div>
                    <div id="toolbarContainer" className="WorkMaintenanceToolbar collapse" ref={toolbarParentRef}>
                        <UsageMaintenanceToolbar
                            scroll={updatedScroll}
                            toolbarWidth={toolbarWidth}
                            toolbarData={usageMaintenanceToolbarData}
                            saveResultData={usageMaintenanceSaveResultData}
                            saveChanges={saveUsage}
                            resetMessageBanner={resetMessageBannerLocal}
                            changesMade={changesMade}
                            usageGroup={usageGroup}
                            activeTab={activeTab}
                            tabs={tabs}
                            showModal={showModal}
                            showYesNoPrompt={showYesNoPrompt}
                            hideModal={hideModal}
                            clearModalSearchResults={clearModalSearchResults}
                            currentUser={currentUser}
                            usageMaintenanceGeneralDataViewData={usageMaintenanceGeneralViewData}
                            workflowFieldsData={workflowFieldsData}
                            isWorkflowSessionStarted={isWorkflowSessionStarted}
                            startWorkflowSession={startWorkflowSession}
                            cancelWorkflowSession={cancelWorkflowSession}
                            nextWorkflowItem={nextWorkflowItem}
                            skipWorkflowItem={skipWorkflowItem}
                            workflowSessionItems={workflowSessionItems}
                            currentWorkflowIndex={currentWorkflowIndex}
                            isOpenForWorkflowSession={isOpenForWorkflowSession}
                            lookupValues={lookupValues}
                            formatFields={formatFields}
                            skipWorkWorkflowItem={skipWorkWorkflowItem}
                            refreshWorkDetails={refreshUsageGroupDetailsLocal}
                            saveWorkflow={saveWorkflow}
                            roles={roles}
                            updateWorkflowAndEntityStatus={updateWorkflowAndEntityStatus}
                            updateClaimWorkflowAndEntityStatus={updateClaimWorkflowAndEntityStatus}
                            completeWorkflowOnSave={completeWorkflowOnSave}
                            getUsageDetails={getUsageDetails}
                            updateUsageField={updateUsageFieldLocal}
                            updateUsagesAdvanced={getUpdateAdvancedRoleEnabled()}
                            paneIndex={paneIndex}
                            saveRegroupedUsageGroup={saveRegroupedUsageGroup}
                            distributionStatus={distributionStatus}
                            enableRegroupAndDeleteUI={enableRegroupAndDeleteUI}
                            setActivePane={setActivePane}
                            showMessage={showMessage}
                            mergeUsage={toolbarMergeUsage}
                            usageGroupMergeOptions={usageGroupMergeOptions}
                        />
                    </div>
                    <button type="button" className="toolbar-toggle" data-toggle="collapse" data-target="#toolbarContainer">
                        <MoreVertical16Regular className="icon" aria-hidden="true" />
                    </button>

                    <UsageMaintenanceGeneralDataView
                        key={id}
                        usageMaintenanceGeneralDataViewData={usageMaintenanceGeneralViewData}
                        title={fullTitle}
                        composer={fullContributor}
                        setListArtist={setListArtist}
                        customerVenues={customerVenues}
                        artist={fullPerformer}
                        editableFieldsDataView={editableFieldsDataView}
                        showUpdateFieldsModal={showUpdateFieldsModal}
                        hideModal={hideModal}
                        editableFields={editableFields}
                        setEditableFields={setEditableFields}
                        dataGridTableData={usageDataGridTableData}
                        distributionCode={distributionCode}
                        matchStatus={matchStatus}
                        allocations={allocations}
                        allocationStatus={allocationStatus}
                        sourceMajor={sourceMajor}
                        sourceMinor={sourceMinor}
                        usageType={usageType}
                        distributions={distributions}
                        licenseesWorkNumber={remittingSocietyWorkCode}
                        usageWeight={totalWeight}
                        weightCategory={calculateWeightCategory(parseFloat(totalWeight) ?? 0)}
                        isReadonly={isReadonly}
                        tabs={tabs}
                        activeTab={activeTab}
                        updateComponentFieldsItems={updateComponentFieldsItems}
                        lookupSources={lookupSources}
                        updateUsageField={updateUsageFieldLocal}
                        lookupValues={lookupValues}
                        roles={roles}
                        productType={productType}
                        showModal={showModal}
                        location={location}
                        setListAdditional={setListAdditional}
                        updateLocation={updateLocation}
                        updateSetListAdditional={updateSetListAdditional}
                        approvalStatus={usageGroup.approvalStatus}
                        enableApprovalStatusEdit={usageGroup.enableApprovalStatusEdit}
                        venueDetails={venueDetails}
                        updateUsageGroupVenueDetails={updateUsageGroupVenueDetails}
                        qaStatus={usageGroup.qaStatus}
                        rejectReason={rejectReason}
                        poolCode={poolCode}
                        catOne={catOne}
                        catTwo={catTwo}
                        licenseVenues={usageGroup.licenseVenues}
                        componentViews={componentViews}
                        setActiveComponentView={onSetActiveComponentView}
                        activeComponentView={usageMaintenanceActiveComponentView}
                        settingsModalViewData={settingsModalViewData}
                        componentViewPreference={componentViewPreference}
                        usages={usageGroup.usages}
                        contributorTypes={contributorTypes}
                        nameTypes={nameTypes}
                        toggleExtendedMetaData={toggleExtendedMetaDataLocal}
                        paneIndex={paneIndex}
                        activeExtendedData={activeExtendedData}
                        defaultActiveExtendedData={defaultActiveExtendedData}
                        relatedPoolOptions={relatedPoolOptions }
                        pools={pools}
                        mergeThisUsage={mergeThisUsage}
                    />
                    {canRenderUsageFields && 
                    <UsageMaintenanceGridsView
                        settingsModalViewData={settingsModalViewData}
                        updateComponentViews={updateComponentViews}
                        getComponentViews={getComponentViews}
                        componentViews={componentViews}
                        isUsageTabDefaultSetToMatchConfiguration={isUsageTabDefaultSetToMatchConfiguration}
                        openedFrom={openedFrom}
                        isValidationWorkFlow={isValidationWorkflow}
                        usageMaintenanceGridViewsDetailsActiveComponentView={usageMaintenanceGridViewsDetailsActiveComponentView}
                        setActiveComponentView={onSetActiveComponentView}
                        activeComponentView={activeComponentView}
                        componentViewPreference={componentViewPreference}
                        roles={roles}
                        usageMaintenanceGridsViewData={usageMaintenanceGridsViewData}
                        usageDataGridTableData={usageDataGridTableData}
                        usageGroup={usageGroup}
                        showModal={showModal}
                        updateUsageField={updateUsageFieldLocal}
                        hideModal={hideModal}
                        clearModalSearchResults={clearModalSearchResults}
                        getWorkDetails={getWorkDetailsLocal}
                        getProductDetails={getProductDetailsLocal}
                        lookupValues={lookupValues}
                        addUsageDetailsShareIPRow={addUsageDetailsShareIPRow}
                        addUsageDetailsRowData={newAddUsageDetailsRowData}
                        resetMessageBanner={resetMessageBanner}
                        showUpdateFieldsModal={showUpdateFieldsModal}
                        editableFields={editableFields}
                        setEditableFields={setEditableFields}
                        editableFieldsDataView={editableFieldsDataView}
                        updateComponentFieldsItems={updateComponentFieldsItems}
                        tabs={tabs}
                        activeTab={activeTab}
                        sources={sources}
                        getUsagePool={getUsagePool}
                        pool={pool}
                        expandedUsageDetailsRow={expandedUsageDetailsRow}
                        expandUsageDetail={expandUsageDetailRow}
                        updatedScroll={updatedScroll}
                        usageMaintenanceMatchingWorksToolbar={usageMaintenanceMatchingWorksToolbar}
                        searchViewData={searchViewData}
                        searchViewDataModal={searchViewDataModal}
                        searchViewDataMatchingLicense={searchViewDataMatchingLicense}
                        searchLicenses={searchLicenses}
                        addMatchLicenseToUsage={addMatchLicenseToUsage}
                        licensesSearchResults={licensesSearchResults}
                        searchResultsTableData={searchResultsTableData}
                        dataSource={dataSource}
                        searchWorks={searchWorks}
                        worksSearchResults={worksSearchResults}
                        expandedWorkResults={expandedWorkResults}
                        expandAll={expandAll}
                        searchSuccessful={searchSuccessful}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        expandWorkResult={expandWorkResult}
                        expandAllResults={expandAllResults}
                        currentPage={currentPage}
                        resetPagination={resetPagination}
                        updatePagination={updatePagination}
                        sortSearchResults={sortSearchResults}
                        username={username}
                        searchUsages={searchUsages}
                        searchMatchWorks={searchMatchWorks}
                        searchMatchProducts={searchMatchProducts}
                        matchWorkSearchResult={matchWorkSearchResult}
                        matchProductsSearchResult={matchProductsSearchResult}
                        expandedMatchWorkResults={expandedMatchWorkResults}
                        distributionTypes={distributionTypes}
                        lookupSources={lookupSources}
                        usageMatchingDefaultsWorks={usageMatchingDefaultsWorks}
                        usageMatchingDefaultsProducts={matchingSearchViewDefaults.usageMatchingSearchDefaultsProducts}
                        addMatchworkToUsage={addMatchworkToUsage}
                        addMatchProductToUsage={addMatchProductToUsage}
                        usageExpandAllResults={usageExpandAllResults}
                        expandMatchWorkResult={expandMatchWorkResultLocal}
                        addNewWork={addNewWork}
                        paneIndex={paneIndex}
                        getUsageDetails={getUsageDetails}
                        formatFields={formatFields}
                        updateUsagesAdvanced={getUpdateAdvancedRoleEnabled()}
                        incrementTempID={incrementTempID}
                        enableRegroupAndDeleteUI={enableRegroupAndDeleteUI}
                        setActivePane={setActivePane}
                        usageNumberInSearchExclude={usageNumberInSearchExclude}
                    />
                    }
                </div>
            );
        }
        else return <div />;
}

export default UsageMaintenancePage;
